// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"6d01380d","213":"19d5abb9","239":"a9dde67a","488":"9cce4594","732":"4a22daa8"}[chunkId] + ".chunk.js";
};